module.exports = __webpack_public_path__ + "img/inventory.646f380a.png";